import { createRouter, createWebHistory } from "vue-router"

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "map",
      component: () => import("@/views/MapView.vue"),
    },
    {
      path: "/comparaison",
      name: "comparative",
      component: () => import("@/views/ComparativeView.vue"),
    },
  ],
})

export default router
